import React, { useEffect, useState } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import variablePie from 'highcharts/modules/variable-pie';

import { useSelector, useDispatch } from 'react-redux'
import { updatePresenceData } from '../../redux/graphs';
import Result from '../Result';

const Presence = () => {
  variablePie(Highcharts);
  const dispatch = useDispatch();

  const presence = useSelector((state) => state.graphs.presence);
  const [options, setOptions] = useState([]);
  // - - - - - - - - - - - - - - - - - - - - - - - - -

  useEffect(() => {
    dispatch(
      updatePresenceData()
    );
  }, []);

  useEffect(() => {
    setOptions (
      {
        chart: {
          type: 'variablepie'
        },
        title: {
          text: 'Presence',
          align: 'left'
        },
        subtitle: {
          text: 'This measures your own perception of your tendencies for handling to good and bad events in 4 dimensions',
          align: 'left'
        },
        tooltip: {
          headerFormat: '',
          pointFormat: '<span style="color:{point.color}">\u25CF</span> <b> ' +
          '{point.name}</b><br/>' +
          'Total score: <b>{point.z}</b><br/>' +
          'Action: <b>{point.action}</b><br/>' +
          'Mindfulness: <b>{point.mindfulness}</b><br/>' +
          'Acceptance: <b>{point.acceptance}</b><br/>' +
          'Awareness: <b>{point.awareness}</b><br/>' 
        },
        series: [{
          minPointSize: 10,
          innerSize: '20%',
          zMin: 0,
          name: 'countries',
          borderRadius: 5,
          data: presence,
          colors: [
            '#00ae00',
            '#3dc3e8',
          ],
        }],
      }
    );
  }, [presence]);

  // ==================================================
  // ==================================================
  return(
    <div className="[&_.highcharts-data-label-connector]:hidden">
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
      />

      <Result
        result_text={"You currently view your overall mental performance as average"}
      />
    </div>
  );
};

export default Presence;